<div class="bottomsheet-dark-view" (click)="closeBottomsheet()">
  <div class="bottomsheet-container" id="bottomsheet">
    <div class="bottomsheet-top">
      <div *ngIf="submit" class="bottomsheet-top-save" (click)="save()">
        ثبت
      </div>
      <div *ngIf="type !== 'blocks'" class="bottomsheet-top-title">
        <span *ngIf="edditing">ویرایش</span> {{ title }}
      </div>
      <div *ngIf="type === 'blocks'" class="bottomsheet-top-title">
        {{ title }}
      </div>
      <div class="bottomsheet-top-close" (click)="closeBottomsheet()">بستن</div>
    </div>
    <div class="bottomsheet-holder">
      <app-edit-name
        *ngIf="type === 'name'"
        [name]="selectedInput"
      ></app-edit-name>
      <app-edit-gender
        *ngIf="type === 'gender'"
        [gender]="selectedInput"
      ></app-edit-gender>
      <app-edit-birthdate
        *ngIf="type === 'birthdate'"
        [birthdate]="selectedInput"
      ></app-edit-birthdate>
      <app-edit-height
        *ngIf="type === 'height'"
        [height]="selectedInput"
      ></app-edit-height>
      <app-edit-name
        *ngIf="type === 'username'"
        [username]="selectedInput"
      ></app-edit-name>
      <app-edit-bio *ngIf="type === 'bio'" [bio]="selectedInput"></app-edit-bio>
      <app-edit-status
        *ngIf="type === 'isPublic'"
        [status]="selectedInput"
      ></app-edit-status>
      <app-edit-block-users *ngIf="type === 'blocks'"></app-edit-block-users>
      <app-edit-phonenumber
        *ngIf="type === 'credentials'"
        [user]="user"
        [phonenumber]="selectedInput"
      ></app-edit-phonenumber>
      <app-support-bottomsheet
        *ngIf="type === 'support'"
      ></app-support-bottomsheet>
      <app-message *ngIf="type === 'message'"></app-message>
    </div>
  </div>
  <app-loading *ngIf="showLoading"></app-loading>
</div>
